import { Center, HStack, Text } from '@chakra-ui/react';

import { IconChevronRight } from './Icons';
import { Link } from './Link';

type NavigationItemProps = {
  title: string;
  icon: JSX.Element;
  url: string;
};

export const SidebarItem = ({ title, icon, url }: NavigationItemProps) => {
  return (
    <Link
      p={2}
      border="1px solid"
      borderColor="gray.50"
      transition="linear 0.1s"
      borderRadius={8}
      w="full"
      _hover={{
        borderColor: 'brand.100',
        bg: 'brand.25',
      }}
      to={url}
    >
      <HStack color="gray.900" fontWeight="medium" justify="space-between">
        <HStack>
          <Center w="2.25rem" h="2.25rem" bg="brand.50" borderRadius={8}>
            {icon}
          </Center>

          <Text fontWeight="medium">{title}</Text>
        </HStack>

        <IconChevronRight color="gray.900" fontSize="20px" />
      </HStack>
    </Link>
  );
};
